import keyData from './keyData';
import createImg from './utils';

export default class Keyboard {
  constructor() {
    this.value = null;
    this.clipboard = '';
    this.capslock = false;
    this.shift = false;
    this.ctrl = false;
    this.alt = false;
    this.sound = true;
    this.recognizer = null;
    this.audio = null;
    this.lang = 'en';
    this.down = { en: [], ru: [] };
    this.caps = { en: [], ru: [] };
    this.shiftArr = { en: [], ru: [] };
  }

  init() {
    if (localStorage.getItem('lang')) {
      this.lang = localStorage.getItem('lang');
      } else {
      localStorage.setItem('lang', this.lang);
    }
    this.#createMonitor();
    this.#createKeys(keyData);
    this.#createAudio();
    this.#createSpeechRecognition();
    this.#createLegend();
    this.#createFooter();
    this.getStorage(keyData);
  }

  #createMonitor() {
    const textAreaWrapper = document.createElement('div');
    textAreaWrapper.classList.add('textarea-wrapper');
    const textArea = document.createElement('textarea');
    this.textArea = textArea;
    const description = document.createElement('p');
    textArea.classList.add('textarea');
    description.classList.add('description');
    description.innerText = 'Change language: Ctrl + Alt.';
    textAreaWrapper.append(textArea);
    document.body.append(textAreaWrapper);
    document.body.append(description);
  }

  #createKeys(keyData_) {
    const keyboardBody = document.createElement('div');
    keyboardBody.classList.add('keyboard');
    document.body.append(keyboardBody);
    keyData_.forEach((item) => {
      const row = document.createElement('div');
      row.classList.add('row');
      keyboardBody.append(row);
      for (let j = 0; j < item.length; j += 1) {
        const key = document.createElement('div');
        const classKey = Object.entries(item[j]);
        key.classList.add('key', `${classKey[0][0]}`);
        key.setAttribute('data-code', `${classKey[0][0]}`);
        const objKey = classKey[0][1];
        const currentLang = this.lang;
        if (this.capslock === false) {
          key.innerText = `${objKey[currentLang].down}`;
        } else {
          key.innerText = `${objKey[currentLang].caps}`;
        }
        row.append(key);
      }
    });
    const lastRow = document.createElement('div');
    lastRow.classList.add('row');
    lastRow.classList.add('row__space-between');
    const controls = this.#getControlsSoundBacklightMic();
    lastRow.append(controls);
    const text = document.createElement('span');
    text.textContent = 'Made for Windows';
    text.classList.add('keyboard_text');
    lastRow.append(text);
    keyboardBody.append(lastRow);
  }

  #createAudio() {
    this.audio = document.createElement('AUDIO');
    this.audio.setAttribute('src', './assets/click.mp3');
    document.body.append(this.audio);
  }

  #createSpeechRecognition() {
    // eslint-disable-next-line new-cap, no-undef
    this.recognizer = new webkitSpeechRecognition();
    this.recognizer.interimResults = true;
    this.recognizer.lang = 'ru-Ru';
    //this.recognizer.lang = this.lang === 'ru' ? 'ru-Ru' : 'en-US';
    this.recognizer.onaudiostart = () => {
      this.textArea.focus();
    };
    this.recognizer.onresult = (e) => {
      const result = e.results[e.resultIndex];
     
      if (result.isFinal) {
        const recText = result[0].transcript;
         console.log(
           'распознавание аудио',
           this.recognizer.lang,
           '<-язык',
           result[0].transcript
         );
        const caretStart = this.textArea.selectionStart;
        this.textArea.value = `${this.textArea.value.slice(
          0,
          this.textArea.selectionStart,
        )}${recText} ${this.textArea.value.slice(
          this.textArea.selectionStart,
        )}`;
        this.textArea.setSelectionRange(
          caretStart + recText.length + 1,
          caretStart + recText.length + 1,
        );
      }
    };
  }

  #getControlsSoundBacklightMic() {
    const controlsWrapper = document.createElement('div');
    controlsWrapper.classList.add('controls-wrapper');

    const soundButton = createImg('./assets/sound.svg', () => { this.sound = !this.sound; });
    soundButton.classList.add('key');
    controlsWrapper.append(soundButton);
    const animationButton = createImg('./assets/light.svg', () => {
      const keyboard = document.querySelector('.keyboard');
      keyboard.classList.toggle('keyboard__animation');
    });
    animationButton.classList.add('key');
    animationButton.textContent = 'Анимация';
    controlsWrapper.append(animationButton);

    const micButton = createImg('./assets/microphone.svg', () => {
      if (window.webkitSpeechRecognition) {
        console.log('Распознавание речи поддерживается');
      }
      console.log('запись аудио', this.recognizer);
      this.recognizer.start();
    });
    micButton.classList.add('key');
    micButton.textContent = 'Микрофон';
    controlsWrapper.append(micButton);

    return controlsWrapper;
  }

  #createLegend(){
        const legend = document.createElement('div');
        legend.classList.add('legend');
        legend.innerHTML =
          '<p>Copy - Ctrl+C</p> <p>Paste - Ctrl+V</p> <p>Cut - Ctrl+X</p> <p>Select All - Ctrl+A</p>';
        document.body.append(legend);
  }
  #createFooter() {
    const footer = document.createElement('footer');
    footer.classList.add('footer');
    const author = document.createElement('span');
    author.textContent = 'Suhakou Henadzi';
    footer.append(author);
    document.body.append(footer);
    const github = createImg('assets/github.svg', () => window.open('https://github.com/UTYFjs'));
    footer.append(github);
  }

  getStorage(keyData_) {
    keyData_.forEach((item) => {
      for (let j = 0; j < item.length; j += 1) {
        const classKey = Object.entries(item[j]);
        const objKey = classKey[0][1];
        if (this.lang === 'en') {
          this.down.en.push(`${objKey.en.down}`);
          this.caps.en.push(`${objKey.en.caps}`);
          this.shiftArr.en.push(`${objKey.en.shift}`);
        } else {
          this.down.ru.push(`${objKey.ru.down}`);
          this.caps.ru.push(`${objKey.ru.caps}`);
          this.shiftArr.ru.push(`${objKey.ru.shift}`);
        }
      }
    });
  }

  changeShift() {
    const keys = document.querySelectorAll('.key');
    for (let i = 0; i < keys.length; i += 1) {
      if (this.shift) {
        keys[i].textContent = this.shiftArr[this.lang][i];
      } else {
        keys[i].textContent = this.down[this.lang][i];
      }
    }
  }

  switchCapsLock() {
    this.capslock = !this.capslock;
  }

  switchShift() {
    this.shift = !this.shift;
  }

  checkAlt() {
    if (this.alt) {
      this.alt = false;
      document.querySelector('.AltLeft').classList.remove('active');
      document.querySelector('.AltRight').classList.remove('active');
    }
  }

  checkCtrl() {
    if (this.ctrl) {
      this.ctrl = false;
      document.querySelector('.ControlLeft').classList.remove('active');
      document.querySelector('.ControlRight').classList.remove('active');
    }
  }

  checkShift() {
    if (this.shift) {
      this.shift = false;
      this.changeShift();
      document.querySelector('.ShiftLeft').classList.remove('active');
      document.querySelector('.ShiftRight').classList.remove('active');
    }
  }
}
